import { AvailabilityDetails } from '../../types/monitoringUpdate'
import useStyles from './Styles/InputBoxValuesRoomTypeMenu.Style'
import TimeCell from './TimeCell'

interface InputBoxValuesRoomTypeMenuProps {
  weekendIndexes: number[]
  index: number
  range: 'TWO_WEEKS' | 'MONTH'
  data: AvailabilityDetails
}

export default function InputBoxValuesRoomTypeMenu({
  weekendIndexes,
  index,
  data,
  range
}: InputBoxValuesRoomTypeMenuProps) {
  const classes = useStyles()
  return (
    <div className={classes.status}>
      <div
        className={[
          classes.dayContainer,
          weekendIndexes.includes(index % 7) ? classes.weekendDayContainer : ''
        ].join(' ')}>
        <TimeCell dataStatus={data} range={range} />
      </div>
    </div>
  )
}
